import { Component, ElementRef, OnInit, Renderer2, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticacaoService } from '../../autenticacao/autenticacao.service';
import { UsuarioSessao } from '../../models/usuario-sessao';
import { ROUTES, RouteInfo } from '../sidebar/sidebar.component';
import { environment } from '../../../environments/environment';

export interface Rota {
  label: string;
  value: string;
  routeInfo: RouteInfo;
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  private toggleButton;
  private sidebarVisible = false;
  private titulo = '';
  rotaItens: any[];
  rota: Rota | undefined = undefined;

  mostrarAlteraBackendModal: boolean;
  paths: { base: string; permiteAlterarBackend: boolean };
  urlNova: string;

  @ViewChild('navbar-cmp')
  button;

  @Input()
  listaDeRotasPermitidas;
  nativeElement: any;
  listTitles: RouteInfo[] = [];

  constructor(
    private router: Router,
    private renderer: Renderer2,
    private element: ElementRef,
    private autenticacaoService: AutenticacaoService
  ) {
    this.nativeElement = element.nativeElement;
    this.setSidebarVisible(false);
    this.paths = environment.paths;
  }

  ngOnInit(): void {
    this.urlNova = localStorage.getItem('urlNova');
    if (this.urlNova) {
      this.paths.base = this.urlNova;
    }

    this.listTitles = ROUTES.filter((listTitle) => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];

    setTimeout(() => {
      const autocompleteDiv = this.element.nativeElement.querySelector('.autocomplete-pages');

      if (autocompleteDiv) {
        const campo = autocompleteDiv.querySelector('input');

        if (campo) {
          this.renderer.setAttribute(campo, 'accesskey', 'b');
        }
      }
    }, 100);
  }

  public getTitulo() {
    return this.titulo ? this.titulo : 'Codex';
  }

  menuToggle() {
    const mainPanel = document.querySelector('.main-panel');
    const sidebar = document.getElementsByClassName('sidebar')[0];
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName('body')[0];
    sidebar.classList.toggle('active');

    if (mainPanel) {
      mainPanel.classList.toggle('active');
    }

    if (this.sidebarVisible === false) {
      setTimeout(function () {
        toggleButton.classList.remove('pi-angle-double-left');
        toggleButton.classList.add('pi-bars');
      }, 500);
      body.classList.add('nav-open');
      sidebar.classList.remove('hidden');
      this.setSidebarVisible(true);
    } else {
      this.toggleButton.classList.remove('pi-bars');
      toggleButton.classList.add('pi-angle-double-left');
      this.setSidebarVisible(false);
      body.classList.remove('nav-open');
      sidebar.classList.add('hidden');
    }
  }

  private setSidebarVisible(value: boolean) {
    this.sidebarVisible = value;
    localStorage.setItem('sidebarVisible', String(value));
  }

  public deslogar(): void {
    this.autenticacaoService.deslogar();
  }

  get usuarioSessao(): UsuarioSessao | undefined {
    return this.autenticacaoService.getUsuarioSessao();
  }

  public onCompleteRota(evento: any): void {
    this.rotaItens = [];
    const consulta = this.normalizar(evento.query);
    this.listaDeRotasPermitidas.forEach((rota) => this.buscarEmRota(consulta, rota));
  }

  private normalizar(texto: string): string {
    return texto
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '');
  }

  private buscarEmRota(consulta: string, rota: RouteInfo, caminho?: string): void {
    const caminhoCompleto = caminho ? `${caminho} > ${rota.title}` : rota.title;
    const caminhoDestacado = this.realcarCorrespondencia(caminhoCompleto, consulta);

    if (this.normalizar(caminhoDestacado).includes(consulta) && (!rota.items || rota.items.length === 0)) {
      this.rotaItens.push({
        label: caminhoDestacado,
        value: caminhoCompleto,
        routeInfo: rota,
      });
    }

    if (rota.items) {
      rota.items.forEach((subRota) => this.buscarEmRota(consulta, subRota, caminhoCompleto));
    }
  }

  private realcarCorrespondencia(texto: string, consulta: string): string {
    const textoNormalizado = this.normalizar(texto);

    let resultado = '';

    let indiceInicial = 0;

    while (indiceInicial < textoNormalizado.length) {
      const indice = textoNormalizado.indexOf(consulta, indiceInicial);

      if (indice === -1) {
        // Se não encontrar mais ocorrências, adiciona o restante do texto e sai do loop
        resultado += texto.substring(indiceInicial);
        break;
      }

      // Adiciona o texto antes da consulta, realçando em negrito
      resultado += texto.substring(indiceInicial, indice);

      // Adiciona a consulta realçada em negrito
      resultado += `<b>${texto.substring(indice, indice + consulta.length)}</b>`;

      // Atualiza o índice inicial para após a consulta
      indiceInicial = indice + consulta.length;
    }

    return resultado;
  }

  realcarHierarquia(texto: string, consulta: string): string {
    const partes = texto.split('>');
    const partesRealcadas = partes.map((part) => this.realcarCorrespondencia(part, consulta));
    const hierarquiaIndentada = partesRealcadas.map((parte, index) => {
      return index > 0 ? ' > ' + parte : parte;
    });
    return hierarquiaIndentada.join('');
  }

  onSelectRota(rota: Rota): void {
    this.rota = undefined;
    this.router.navigate([rota.routeInfo.path]);
  }

  alterarBackendUrl() {
    this.paths.base = this.urlNova;
    localStorage.setItem('urlNova', this.urlNova);
    this.fecharBackendModal();
    location.reload();
  }

  abrirBackendModal() {
    this.mostrarAlteraBackendModal = true;
  }

  fecharBackendModal() {
    this.mostrarAlteraBackendModal = false;
  }
}
